import { useNavigate } from 'react-router-dom'

import { Box, Grid, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { List, ListItem } from 'components/ui'
import { useMappedTranslation } from 'hooks'
import { Paper } from 'oneui'
import { IconStyle, SummaryPaperStyle } from 'styles/theme/theme'
import { EVENT_KEYS } from 'utils/constants'

import IconSecurity from '../assets/images/security.svg'
import IconWarning from '../assets/images/warning.png'

const SeparatedCard = (props) => {
  const { activity, securityEvent } = props

  const t = useMappedTranslation()
  const navigate = useNavigate()
  const theme = useTheme()

  const handleSecurityPage = () => {
    navigate(securityEvent.link, { state: { isPasswordLeakDetectionEnabled: false } })
  }

  const handleDashboardSecurityActivities = () => {
    navigate('/dashboard/security/activities')
  }

  return (
    <Box sx={{ height: { xs: 'auto', md: '400px' } }}>
      <Box
        tabIndex={0}
        onClick={handleSecurityPage}
        onKeyDown={(event) => {
          if (event.key === EVENT_KEYS.SPACE || event.key === EVENT_KEYS.ENTER) {
            event.preventDefault()
            handleSecurityPage()
          }
        }}
        sx={{ cursor: 'pointer' }}
        data-testid='Box9936E619'
      >
        <Paper
          sx={{
            ...SummaryPaperStyle,
            height: { xs: '100%', md: '192px' },
            minHeight: '163px',
            marginBottom: '16px'
          }}
        >
          <Stack justifyContent='flex-start' alignItems='center' sx={{ height: '100%' }}>
            <Grid container alignItems='center' wrap='nowrap' sx={{ marginBottom: { xs: '24px', md: '16px' } }}>
              <Box component='img' src={IconWarning} sx={{ ...IconStyle }} alt='' />
              <Box sx={{ mx: { xs: '16px', md: '18px' } }}>
                <Typography
                  fontSize={{ xs: '17px', md: '18px' }}
                  fontWeight='bold'
                  sx={{
                    textTransform: 'uppercase',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: '2',
                    WebkitBoxOrient: 'vertical'
                  }}
                >
                  {securityEvent.title}
                </Typography>
              </Box>
            </Grid>
            <Box>
              <Typography
                sx={{
                  overflow: 'hidden',
                  display: '-webkit-box',
                  WebkitLineClamp: '3',
                  WebkitBoxOrient: 'vertical'
                }}
              >
                {securityEvent.description}
              </Typography>
            </Box>
          </Stack>
        </Paper>
      </Box>
      <Box
        tabIndex={0}
        onClick={handleDashboardSecurityActivities}
        onKeyDown={(event) => {
          if (event.key === EVENT_KEYS.SPACE || event.key === EVENT_KEYS.ENTER) {
            event.preventDefault()
            handleDashboardSecurityActivities()
          }
        }}
        sx={{ cursor: 'pointer' }}
        data-testid='Box23994BCE'
      >
        <Paper
          sx={{
            height: { xs: '100%', md: '192px' },
            minHeight: '180px',
            borderRadius: '26px',
            border: 'none',
            padding: { xs: '30px 30px 24px', md: '40px' }
          }}
        >
          <Stack justifyContent='flex-start' alignItems='center' sx={{ height: '100%' }}>
            <Grid container alignItems='center' wrap='nowrap' sx={{ marginBottom: '16px' }}>
              <Box component='img' src={IconSecurity} sx={{ ...IconStyle }} alt='' />
              <Box sx={{ mx: { xs: '16px', md: '18px' } }}>
                <Typography
                  fontSize={{ xs: '17px', md: '18px' }}
                  fontWeight='bold'
                  sx={{ textTransform: 'uppercase', overflowWrap: 'anywhere' }}
                >
                  {t('security.title')}
                </Typography>
              </Box>
            </Grid>
            <Box
              sx={{
                display: 'flex',
                height: '100%',
                width: { xs: 'calc(100% + 2px)', md: '100%' },
                marginLeft: { xs: '-2px', md: '0' },
                alignItems: 'center',
                pt: { xs: '14px', md: '18px' },
                pb: { xs: '16px', md: '18px' }
              }}
            >
              <List sx={{ width: '100%', padding: '0' }}>
                <ListItem
                  icon={activity.icon}
                  iconItemSx={{ minWidth: { xs: '48px', md: '56px' } }}
                  iconSx={{
                    width: { xs: '36px', md: '40px' },
                    height: { xs: '36px', md: '40px' },
                    marginLeft: { xs: '-2px', md: '0' }
                  }}
                  title={t('security.recentActivity')}
                  titleSx={{
                    '& p': {
                      fontSize: '12px',
                      fontWeight: { xs: '500' },
                      lineHeight: { xs: '16px', md: '14px' },
                      color: theme.palette.secondary.light
                    },
                    minHeight: { xs: '16px', md: '14px' },
                    lineHeight: { xs: '16px', md: '14px' },
                    pb: { xs: '2px', md: '4px' }
                  }}
                  description={
                    <Typography
                      sx={{
                        wordBreak: 'break-all',
                        fontSize: { xs: '16px' },
                        lineHeight: { xs: '22px', md: '20px' },
                        fontWeight: { xs: '500' }
                      }}
                    >
                      {activity.description}
                    </Typography>
                  }
                  fullWidth={true}
                />
              </List>
            </Box>
          </Stack>
        </Paper>
      </Box>
    </Box>
  )
}

export default SeparatedCard
